/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Experience_Level7_Interactive_MetricsInputs */

const en_experience_level7_interactive_metrics = /** @type {(inputs: Experience_Level7_Interactive_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Production-grade delivery`)
};

const ar_experience_level7_interactive_metrics = /** @type {(inputs: Experience_Level7_Interactive_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسليم بمستوى الإنتاج`)
};

const bn_experience_level7_interactive_metrics = /** @type {(inputs: Experience_Level7_Interactive_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রোডাকশন-গ্রেড ডেলিভারি`)
};

const de_experience_level7_interactive_metrics = /** @type {(inputs: Experience_Level7_Interactive_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lieferung in Produktionsqualität`)
};

const es_experience_level7_interactive_metrics = /** @type {(inputs: Experience_Level7_Interactive_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega en grado de producción`)
};

const fr_experience_level7_interactive_metrics = /** @type {(inputs: Experience_Level7_Interactive_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Livraison de qualité production`)
};

const pt_experience_level7_interactive_metrics = /** @type {(inputs: Experience_Level7_Interactive_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrega em nível de produção`)
};

const zh_experience_level7_interactive_metrics = /** @type {(inputs: Experience_Level7_Interactive_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生产级交付`)
};

const tr_experience_level7_interactive_metrics = /** @type {(inputs: Experience_Level7_Interactive_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Üretim düzeyinde teslimat`)
};

const ru_experience_level7_interactive_metrics = /** @type {(inputs: Experience_Level7_Interactive_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доставка промышленного уровня`)
};

const pl_experience_level7_interactive_metrics = /** @type {(inputs: Experience_Level7_Interactive_MetricsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dostawa na poziomie produkcyjnym`)
};

/**
* | output |
* | --- |
* | "Production-grade delivery" |
*
* @param {Experience_Level7_Interactive_MetricsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const experience_level7_interactive_metrics = /** @type {((inputs?: Experience_Level7_Interactive_MetricsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Experience_Level7_Interactive_MetricsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_experience_level7_interactive_metrics(inputs)
	if (locale === "bn") return bn_experience_level7_interactive_metrics(inputs)
	if (locale === "de") return de_experience_level7_interactive_metrics(inputs)
	if (locale === "es") return es_experience_level7_interactive_metrics(inputs)
	if (locale === "fr") return fr_experience_level7_interactive_metrics(inputs)
	if (locale === "pt") return pt_experience_level7_interactive_metrics(inputs)
	if (locale === "zh") return zh_experience_level7_interactive_metrics(inputs)
	if (locale === "tr") return tr_experience_level7_interactive_metrics(inputs)
	if (locale === "ru") return ru_experience_level7_interactive_metrics(inputs)
	if (locale === "pl") return pl_experience_level7_interactive_metrics(inputs)
	return en_experience_level7_interactive_metrics(inputs)
});